import React from 'react';
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import isEqual from "lodash/isEqual";

import {cancelWizardGroupsChanges, saveWizardList} from "./wizardActions";


const WizardSetupFooter = (props) => {

  const {wizardPendingList, wizardList, routeParams, cancelWizardGroupsChanges, saveWizardList} = props;
  const {wizardId} = routeParams;

  const handleFooterCancelClick = () => {
    if (wizardId) {
      if (wizardPendingList.length && !(isEqual(wizardPendingList, wizardList))) { // should be executed always for now
        cancelWizardGroupsChanges();
      } else {
        hashHistory.push("/wizard");
      }
    } else {
      hashHistory.push("/");
    }
  }

  const handleFooterSaveClick = async () => {
    if (wizardId) {
      const saved = await saveWizardList();
      if (saved) {
        hashHistory.push("/wizard");
      }
    } else {
      const saved = await saveWizardList();
      if (saved) {
        hashHistory.push("/");
      }
    }
  }

  const saveDisabled = false;

  return (
    <div className="app-content-footer app-content-footer--fixed">
      <div className="app-content-footer__buttons">
        <button className="ui-button ui-button--blue" onClick={handleFooterCancelClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.cancel"/>
          </span>
        </button>
        <button className={"ui-button ui-button--green ui-button--large" + (saveDisabled ? " ui-button--disabled" : "")}
                disabled={saveDisabled}
                onClick={handleFooterSaveClick}>
          <span className="ui-button-text ui-button--uppercase">
            <FormattedMessage id="messageBox.buttons.save"/>
          </span>
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPendingList, wizardList} = store.wizardState;
  return {
    wizardPendingList,
    wizardList,
  };
};

const mapDispatchToProps = {
  cancelWizardGroupsChanges,
  saveWizardList,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardSetupFooter);
